import { GetStaticPropsContext, GetStaticPropsResult } from 'next'

import { TermsOfUse } from '@/modules/termsAndPrivacy/pages/TermsOfUse'

export async function getStaticProps(
  _: GetStaticPropsContext,
): Promise<GetStaticPropsResult<{}>> {
  return {
    props: {},
  }
}

export default TermsOfUse
